"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typesImpl = void 0;
const variant_1 = require("./variant");
function typesImpl(key) {
    function types(content) {
        if (Array.isArray(content)) {
            if (content.length && (0, variant_1.isVariantCreator)(content[0])) {
                return content.map(c => c.output.type);
            }
            else {
                return content.map(c => c[key]);
            }
        }
        else {
            return Object.values(content).map(c => c.output.type);
        }
    }
    function inferTypes(_) {
        return new Proxy({}, {
            get: (_, property) => {
                return property;
            }
        });
    }
    return { types, inferTypes };
}
exports.typesImpl = typesImpl;
